/**
 * Created by rossd on 5/31/2018.
 */

import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper'
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect'
import connectedAuthWrapper from 'redux-auth-wrapper/connectedAuthWrapper'
import { isEmpty } from 'react-redux-firebase'

import LoadingSpinner from '../components/LoadingSpinner/LoadingSpinner'


/**
 * @description Higher Order Component that redirects to `/login` instead
 * rendering if user is not authenticated (default of redux-auth-wrapper).
 * @param {Component} componentToWrap - Component to wrap
 * @return {Component} wrappedComponent
 */

const locationHelper = locationHelperBuilder({})


export const UserIsAuthenticated = connectedRouterRedirect({
    wrapperDisplayName: 'UserIsAuthenticated',
    LoadingComponent: LoadingSpinner,
    redirectPath: '/login',
    authenticatedSelector: ({ firebase: { auth } }) =>{
        return !isEmpty(auth)},
    authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
    !auth.isLoaded || isInitializing

})

/**
 * @description Higher Order Component that redirects to listings page or most
 * recent route instead rendering if user is not authenticated. This is useful
 * routes that should not be displayed if a user is logged in, such as the
 * login route.
 * @param {Component} componentToWrap - Component to wrap
 * @return {Component} wrappedComponent
 */
export const UserIsNotAuthenticated = connectedRouterRedirect({
    wrapperDisplayName: 'UserIsNotAuthenticated',
    allowRedirectBack: false,
    LoadingComponent: LoadingSpinner,
    redirectPath: (state, ownProps) => locationHelper.getRedirectQueryParam(ownProps) || '/dashboard',
    authenticatedSelector: ({ firebase: { auth } }) =>{
        return isEmpty(auth)
    },
    authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
    !auth.isLoaded || isInitializing
})

const visibleOnlyAdmin = connectedAuthWrapper({
    authenticatedSelector: ({ firebase: { profile } }) => profile.role !== null && (profile.role==="Admin" || profile.role==="SuperAdmin"),
    wrapperDisplayName: 'VisibleOnlyAdmin',
})

export const UserIsAdmin = connectedRouterRedirect({ // eslint-disable-line new-cap
    authenticatingSelector: ({ firebase: { profile, auth, isInitializing } }) => !auth.isLoaded || isInitializing,
    redirectPath: (state, ownProps) => '/dashboard',
    authenticatedSelector: ({ firebase: { auth,profile } }) =>{
        return !isEmpty(auth) && !isEmpty(profile) && (profile.role==="Admin" || profile.role==="SuperAdmin")
    },
    allowRedirectBack: false,
    wrapperDisplayName: 'UserIsAdmin',
    LoadingComponent: LoadingSpinner,
});

export default {
    UserIsAuthenticated,
    UserIsNotAuthenticated,
    UserIsAdmin
}


// WEBPACK FOOTER //
// ./src/utils/AuthRouter.js